var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRemoteMonitoring(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.118 63h27.764a2 2 0 0 0 1.789-2.9L31 56.764V38a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v18.764l-1.671 3.342A2 2 0 0 0 3.118 63zM5 38h24v18H5zm-.382 20h24.765l1.5 3H3.118zM63 27h-3v-9.5a6.006 6.006 0 0 0-6-6h-.765a5.75 5.75 0 1 0-6.47 0H46a6.006 6.006 0 0 0-6 6V27h-3v2h26zM46.25 6.75A3.75 3.75 0 1 1 50 10.5a3.755 3.755 0 0 1-3.75-3.75zM53.67 27h-7.34l-1.125-6H54.8zM58 27h-2.3l1.278-6.816A1 1 0 0 0 56 19H44a1 1 0 0 0-.982 1.184L44.3 27H42v-9.5a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4z",
    fill: "#ffa500",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 24,
    r: 1,
    fill: "#ffa500",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 39.5h2v3h-2zM22.112 43.31l1.206-2.747 1.833.804-1.206 2.748zM8.87 41.376l1.832-.804 1.206 2.748-1.832.804zM17 44.5c-5.321 0-9.528 4.115-9.7 4.291a1 1 0 0 0 0 1.418c.176.176 4.383 4.291 9.7 4.291s9.528-4.115 9.7-4.291a1 1 0 0 0 0-1.418c-.172-.176-4.379-4.291-9.7-4.291zm-3.162 7.422a15.27 15.27 0 0 1-4.31-2.422 15.27 15.27 0 0 1 4.31-2.422 3.919 3.919 0 0 0 0 4.844zM17 51.5a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm3.162.422a3.919 3.919 0 0 0 0-4.844 15.27 15.27 0 0 1 4.31 2.422 15.27 15.27 0 0 1-4.31 2.422zM10 12h17.827l-2.4 1.681 1.146 1.638 5-3.5a1 1 0 0 0 0-1.638l-5-3.5-1.146 1.638 2.4 1.681H9a1 1 0 0 0-1 1v21h2zM36.427 53.819l5 3.5 1.146-1.638-2.4-1.681H55a1 1 0 0 0 1-1V34h-2v18H40.173l2.4-1.681-1.146-1.638-5 3.5a1 1 0 0 0 0 1.638z",
    fill: "#ffa500",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoteMonitoring);
export default __webpack_public_path__ + "static/media/remote-monitoring.8e1460337851788079a89b61d3c2f177.svg";
export { ForwardRef as ReactComponent };